/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgObjectIr = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M16 5a3 3 0 1 1 1.714 2.711L16 9.426v1.85h-2V10h-4v4h.852v2h-1.45l-1.698 1.699a3 3 0 1 1-1.418-1.41L8 14.574V9.426L6.286 7.71A3 3 0 1 1 7.704 6.3L9.403 8h5.194l1.7-1.699A2.99 2.99 0 0 1 16 5zm3-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM5 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm0 14a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
        <path d="M12.852 13.276V22h1.872v-8.724zm3.574 0V22h1.86v-3.432l1.188.3L21.322 22h2.064l-2.184-3.468c.576-.184 1.02-.492 1.332-.924.32-.432.48-.956.48-1.572 0-.88-.28-1.56-.84-2.04s-1.36-.72-2.4-.72zm2.772 4.068h-.912V14.8h.912c.728 0 1.232.096 1.512.288.288.184.432.512.432.984s-.144.804-.432.996c-.28.184-.784.276-1.512.276z" />
      </g>
    </g>
  </Icon>
);
export { SvgObjectIr as ObjectIr };
